export default __webpack_public_path__ + "static/media/mysite.77c6962d.jpeg";